import type { OrderEventDocumentRef } from '@klear/upload/order-event-documents'
import { assignTrimmedField } from '@klear/schema/patch'
import { PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE } from '@klear/constants'
import { DEFAULT_CURRENCY_CODE, type CurrencyCode } from '@klear/constants/currency'
import { KlearDate } from '@klear/date'
import type { ProofOfAcceptance } from '@klear/proof-of-acceptance/proof-of-acceptance'
import type {
  ProofOfAcceptanceCreateWire,
  ProofOfAcceptanceUpdateWire
} from '@klear/proof-of-acceptance/proof-of-acceptance.wire'

export type ProofOfAcceptanceForm = {
  effectiveDate: KlearDate
  notes: string
  currency: CurrencyCode
}

export const EMPTY_PROOF_OF_ACCEPTANCE_FORM: ProofOfAcceptanceForm = {
  effectiveDate: KlearDate.today(),
  notes: '',
  currency: DEFAULT_CURRENCY_CODE
}

export function proofOfAcceptanceToForm(proof: ProofOfAcceptance): ProofOfAcceptanceForm {
  return {
    effectiveDate: proof.effectiveDate,
    notes: proof.notes ?? '',
    currency: DEFAULT_CURRENCY_CODE
  }
}

export function createProofOfAcceptanceForm(): ProofOfAcceptanceForm {
  return { ...EMPTY_PROOF_OF_ACCEPTANCE_FORM, effectiveDate: KlearDate.today() }
}

export function proofOfAcceptanceFormToCreateWire(
  form: ProofOfAcceptanceForm,
  orderId: number,
  parentEventId: number | undefined
): ProofOfAcceptanceCreateWire {
  const wire: ProofOfAcceptanceCreateWire = {
    orderId,
    effectiveDate: form.effectiveDate.toJSON()
  }
  assignTrimmedField(wire, 'notes', form.notes)
  if (parentEventId != null && parentEventId > 0) wire.parentEventId = parentEventId
  return wire
}

export function proofOfAcceptanceFormToUpdateWire(
  form: ProofOfAcceptanceForm,
  parentEventId: number | undefined
): ProofOfAcceptanceUpdateWire {
  const wire: ProofOfAcceptanceUpdateWire = {
    effectiveDate: form.effectiveDate.toJSON(),
    notes: form.notes.trim() || null
  }
  if (parentEventId != null && parentEventId > 0) wire.parentEventId = parentEventId
  return wire
}

export type ProofOfAcceptanceEventFormValues = ProofOfAcceptanceForm & {
  type: typeof PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE
  documents?: OrderEventDocumentRef[]
  files?: File[]
}

export function proofOfAcceptanceToEventForm(proof: ProofOfAcceptance): ProofOfAcceptanceEventFormValues {
  return {
    type: PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
    ...proofOfAcceptanceToForm(proof),
    documents: []
  }
}

export function createProofOfAcceptanceEventForm(): ProofOfAcceptanceEventFormValues {
  return {
    type: PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
    ...createProofOfAcceptanceForm(),
    documents: []
  }
}
